/*
 * @Author: Json Chen
 * @Date: 2021-09-27 18:49:00
 * @LastEditTime: 2022-06-15 17:39:34
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/SubscriptionBuy/Detail/SubscriptionDiscount/index.tsx
 */
import React from 'react';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
//import css from './css.module.less';
//import { Form } from 'src/components/Antd';
import Card from '../Card';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const _base = 'subscriptionBuyDiscount';
const _direct = [_base, 'enableDirectDiscount'];
const _radioName = [_base, 'type'];
const _percent = [_base, 'percent'];
const _fixAmount = [_base, 'fixAmount'];
const _enableGifts = [_base, 'enableGifts'];
const _gifts = [_base, 'gifts'];

const SubscriptionDiscount = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const { currency, disableEdit } = props;
  return (
    <SectionWrapper
      title={getI18n(
        'salesChannelSubscriptionBuy.discount.subscriptionBuyDiscount',
      )}
      style={{ paddingBottom: 32 }}>
      <Card
        directCheckName={_direct}
        radioName={_radioName}
        percentageName={_percent}
        reductionAmountName={_fixAmount}
        currency={currency}
        enableProductName={_enableGifts}
        productTableName={_gifts}
        tableId={`SalesChannelSubscriptionTable-only`}
        disableEdit={disableEdit}
      />
    </SectionWrapper>
  );
};
export default SubscriptionDiscount;
